export enum SIDEMENU_ID {
  // Side Menu
  EJEMPLO_SIDEBAR = 1,
  EJEMPLO_SIDEBAR_SEGUNDO,
}
